// extracted by mini-css-extract-plugin
module.exports = {"container":"header_container__2cm1J","text":"header_text__2fJpl","imageWrapper":"header_imageWrapper__TC_gR"};